'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.provider("security", function ($httpProvider) {
  var roles = {
    INTRA_TAELYS: "INTRA_TAELYS"
  };
  var authenticationToken, compteId;
  return {
    $get: function $get($http, $window, $location, $APP_NAME, $session) {
      // Chaque fois que l'onglet obtient le focus, on repose le contenu du cookie d'authent de manière à ce qu'un nouvel onglet ouvert puisse le récupérer
      angular.element($window).bind('focus', function () {
        $.cookie('authenticationToken', authenticationToken, {
          path: '/'
        });
        if (compteId) {
          $.cookie('compteId', compteId, {
            path: '/'
          });
        } else {
          $.removeCookie('compteId', {
            path: '/'
          });
        }
        console.log('focus - set compteId to', compteId);
      });
      var deconnect = function deconnect() {
        $http.post('/rest/authentication/logout').then(function (response) {
          $.removeCookie('authenticationToken', {
            path: '/'
          });
          $.removeCookie('compteId', {
            path: '/'
          });
          sessionStorage.removeItem("compteId");
          sessionStorage.removeItem("authenticationToken");
          // par securité, mais ne sert plus à rien... juste pour nettoyer l'ancien comportement en 2020.5
          localStorage.removeItem("compteId");
          $window.location.href = response.data.response; // PGA : on redirige vers la home de la prod pour le moment.
        });
      };
      var setAuthenticationToken = function setAuthenticationToken() {
        authenticationToken = $location.search().authenticationToken || sessionStorage.getItem('authenticationToken') || $.cookie('authenticationToken');
        // Stocke le contenu du cookie d'authent de manière à ce qu'un nouvel onglet ouvert puisse le récupérer
        $.cookie('authenticationToken', authenticationToken, {
          path: '/'
        });
        // Stocke en sessionStorage pour que les appels ulterieurs (et le reload de l'appli) retrouvent bien la session courante
        sessionStorage.setItem("authenticationToken", authenticationToken);
        $httpProvider.defaults.headers.common['authenticationToken'] = authenticationToken;
      };
      var setAppId = function setAppId() {
        $httpProvider.defaults.headers.common['appId'] = $APP_NAME;
      };
      var setCompteId = function setCompteId() {
        if ($APP_NAME !== "INTRA") {
          compteId = $location.search().toCompte || sessionStorage.getItem("compteId") || $.cookie('compteId');
          if (compteId) {
            console.log('set compteId to', compteId);
            $httpProvider.defaults.headers.common['compteId'] = compteId;
            sessionStorage.setItem("compteId", compteId);
            $.cookie('compteId', compteId, {
              path: '/'
            });
          }
        } else {
          console.log('clean compteId');
          sessionStorage.removeItem("compteId");
          $.removeCookie('compteId', {
            path: '/'
          });
          compteId = null;
          delete $httpProvider.defaults.headers.common.compteId;
        }
      };
      return {
        getTokens: function getTokens() {
          var tokens = {
            authenticationToken: authenticationToken,
            appId: $APP_NAME
          };
          if (compteId != null) {
            tokens.compteId = compteId;
          }
          return tokens;
        },
        initAuthentication: function initAuthentication() {
          setAuthenticationToken();
          setAppId();
          setCompteId();

          // we cleanup transfert parameters
          var search = $location.search();
          if (search.toCompte || search.authenticationToken) {
            $location.search(_.omit($location.search(), "toCompte", "authenticationToken"));
          }
        },
        exit: function exit() {
          if ($APP_NAME === "INTRA") {
            deconnect();
          } else {
            var user = $session.getUser();
            if (_.includes(user.habilitations, roles.INTRA_TAELYS)) {
              $window.location.href = "/intra/";
            } else {
              deconnect();
            }
          }
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/security/security.js
// module id = 2723
// module chunks = 13